/**
 * Atlas mission registry.
 *
 * This is the single place that knows which missions exist. Order matters —
 * the Dock lists missions in this order, and `chooseCurrentMission` (in
 * AtlasProvider) scans for the first non-complete, non-snoozed one.
 */
import type { AtlasMission, AtlasMissionId } from '../atlas.types';
import { welcomeMission } from './welcome';
import { createOrganizationMission } from './createOrganization';
import { addFirstProductMission } from './addFirstProduct';
import { settingsMission } from './settings';
import { analyticsMission } from './analytics';
import { calendarMission } from './calendar';
import { forecastMission } from './forecast';
import { releasesMission } from './releases';
import { reportsMission } from './reports';
import { commitmentMission } from './commitment';
import { postUpdateJourneyMission } from './postUpdateJourney';

export const ATLAS_MISSIONS: AtlasMission[] = [
  welcomeMission,
  createOrganizationMission,
  addFirstProductMission,
  settingsMission,
  analyticsMission,
  postUpdateJourneyMission,
  calendarMission,
  releasesMission,
  forecastMission,
  // `reportsMission` (`first-report`) re-enabled in Iteration 7 with the new
  // 5-step flow and the `reports.access` permission gate (Owner / Admin only).
  // Members never see it — see `chooseCurrentMission.ts` for the filter.
  reportsMission,
  commitmentMission,
];

export function getMissionById(id: AtlasMissionId): AtlasMission | undefined {
  return ATLAS_MISSIONS.find((m) => m.id === id);
}

export {
  welcomeMission,
  createOrganizationMission,
  addFirstProductMission,
  settingsMission,
  analyticsMission,
  calendarMission,
  forecastMission,
  releasesMission,
  reportsMission,
  commitmentMission,
  postUpdateJourneyMission,
};
